export default () => ({
  config: {},
  choice: {},
  priceNetto: 0,
  labels: {
    own_contribution: [
      {
        label: '0 %',
        value: '0',
      },
      {
        label: '10 %',
        value: '10',
      }
    ],
    length: [
      {
        label: '12 miesięcy',
        value: '12',
      },
      {
        label: '24 miesiące',
        value: '24',
      },
    ],
    km_limit: [
      {
        label: '10 tys',
        value: '10000',
      },
      {
        label: '20 tys',
        value: '20000',
      },
      {
        label: '30 tys',
        value: '30000',
      },
      {
        label: '40 tys',
        value: '40000',
      },
    ]
  },

  init() {
    this.parseConfig();
    this.parsePriceNetto();
    this.setDefaultChoice();
  },

  ownContributionPrice() {
    const combination = this.choiceMatchingExistingCombination();
    if (!combination) {
      return 'Brak finansowania z tym wkładem';
    }

    const ownContributionPercent = parseFloat(combination.own_contribution);
    const price = this.priceNetto * (ownContributionPercent / 100);

    return `${this.formatPriceSpaceThousands(Math.round(price))} zł`;
  },

  monthlyFeeBrutto() {
    const combination = this.choiceMatchingExistingCombination();
    if (!combination) {
      return '----';
    }

    const price_netto = parseFloat(combination.monthly_fee);
    const price_brutto = price_netto * 1.23;

    return `${Math.round(price_brutto)} zł`;
  },

  carPriceNetto() {
    return `${this.formatPriceSpaceThousands(this.priceNetto)} zł`;
  },

  carPriceBrutto() {
    return `${this.formatPriceSpaceThousands(Math.round(this.priceNetto * 1.23))} zł`;
  },

  formatPriceSpaceThousands(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },

  monthlyFeeNetto() {
    const combination = this.choiceMatchingExistingCombination();
    if (!combination) {
      return '----';
    }

    return `${combination.monthly_fee} zł`;
  },

  choiceMatchingExistingCombination() {
    const found = this.config.find((combination) => {
      if (parseInt(combination?.monthly_fee ?? 0) === 0) {
        // if the combination has no monthly fee defined, we treat it as non-existing
        return false;
      }

      return (
        combination.own_contribution === this.choice.own_contribution &&
        combination.length === this.choice.length &&
        combination.km_limit === this.choice.km_limit
      );
    });

    if (!found) {
      return false;
    }

    return found;
  },

  getLabel(label, value) {
    const labels = this.labels[label] ?? [];
    const found = labels.find((item) => item.value === value);

    return found ? found.label : '';
  },

  setDefaultChoice() {
    if (!this.config.length) {
      return;
    }

    this.config.forEach((item) => {
      if (item?.is_default ?? false) {
        this.choice = JSON.parse(JSON.stringify(item));
      }
    });
  },

  parsePriceNetto() {
    const priceNetto = this.$el.getAttribute('data-price-netto');
    if (priceNetto) {
      this.priceNetto = parseInt(priceNetto);
    }
  },

  parseConfig() {
    const data = this.$el.getAttribute('data-config') || '{}';
    const decodedData = data.replace(/&quot;/g, '"');
    let config = {};

    try {
      config=JSON.parse(decodedData);
    } catch (e) {
      console.error('Error parsing BlockCalcSale JSON', e);
    }

    console.log(config);
    this.config = config;
  },
});
